var anchorsFix = {

    init: function () {
        $(document).ready(function() {
            var pathname = window.location.href.split('#')[0];
            $('a[href^="#"]').each(function() {
                if ($(this).is('[role="tab"]') || $(this).closest('.letter-selector').length) {
                    return;
                }
                var $this = $(this),
                    link = $this.attr('href');
                $this.attr('href', pathname + link);
            });
        });
    },

};

var carousel = {

    init: function () {

        if (typeof $.fn.owlCarousel !== "function") {
            return;
        }

        $('.owl-carousel:not(.owl-loaded)').each(function () {
            var $this = $(this);

            // Récupération des informations responsive
            var responsiveData = $this.data('responsive');
            var responsiveObject = {};
            if (responsiveData) {
                for (var i in responsiveData) {
                    responsiveObject[i] = {
                        items: responsiveData[i]
                    };
                }
            }

            var mouseDrag = $this.data('mouse-drag');
            if (typeof mouseDrag === 'undefined') {
                mouseDrag = true;
            }

            $(this).owlCarousel({
                autoplay: $this.data('autoplay') || false,
                autoplayTimeout: $this.data('autoplay-interval') || 5000,
                autoplayHoverPause: $this.data('autoplay-hover-pause') || false,
                loop: $this.data('loop') || false,
                margin: $this.data('margin') || 10,
                nav: $this.data('nav') || false,
                dots: $this.data('dots') || false,
                center: $this.data('center') || false,
                stagePadding: $this.data('stage-padding') || 0,
                lazyLoad: $this.data('lazy-load') || false,
                video: $this.data('video') || false,
                items: $this.data('items') || 3,
                mouseDrag: mouseDrag,
                touchDrag: mouseDrag,
                responsive: responsiveObject,
                responsiveBaseElement: $this.data('responsive-base-element') || window,
                autoWidth: $this.data('auto-width') || false,
            });
        });

    },

    refresh: function () {
        $('.owl-carousel.owl-loaded').owlCarousel('refresh');
    },

};


/*
BOUTON Ajout Au Panier
 */
var addCheckout = {
    init: function () {
        this.setListeners();
    },

    setListeners: function ($selector) {
        if (typeof $selector === 'undefined') {
            $selector = $('body');
        }

        $selector.find('div.addCheckout').on('click', 'button', function (e) {
            e.preventDefault();

            // Récupération
            var div = $(this).closest('div.addCheckout');
            var idproduit = div.data('idproduit');
            var stock = div.data('stock');
            var stockPrevente = div.data('stock-prevente') || 0;

            // Récupération quantité
            var qte = 1;
            if (div.parent().find('#qty').length) {
                var select = div.parent().find('#qty');
                qte = parseInt(select.val());
            }

            // Requête
                addCheckout.addItem($(this), idproduit, qte, stock, stockPrevente);
        })
    },

    addItem: function ($element, idproduit, qte, stock, stockPrevente) {
        $element.prop('disabled', true);

        loadingState.start($('.cube-produit a, .cube-produit .btn'));

        $.get("/websvc/additem.ws.php?idproduit=" + idproduit + "&qte=" + qte + "&nbencaddie=0&nbstock=" + stock + "&nbstockprevente=" + stockPrevente + "&redir=1&nocache=" + Math.random())
            .done(function (data, status, xhr) {

                popin.open(data.html);

                var $popin = $(popin.selector);

                $popin
                    .on('click', 'button.seeCheckout', function (e) {
                        e.preventDefault();
                        window.location = '/caddie/';
                    })
                    .on('click', 'button.backToProducts', function (e) {
                        e.preventDefault();
                        popin.close();
                    });

                carousel.init();


                setTimeout(function () {
                    carousel.refresh();

                    addCheckout.setListeners($popin);
                }, 200);

            })
            .always(function () {
                $element.prop('disabled', false);
                loadingState.end();
            });
    }
};

/**
 * NameSpace qui gere le stylage spécifique des inputs sur AVDJ.
 */
var filledInputs = {

    // Sélecteur de l'élément à analyser
    selectorToTrigger: '.main input, .main textarea',

    init: function () {
        this.setInputFilledListener();

        // On déclenche le listener une fois pour les champs préremplis.
        $(this.selectorToTrigger).trigger('input');
    },

    setInputFilledListener: function () {
        $(this.selectorToTrigger)
            .off('input.filled')
            // Si on modifie le contenu d'un input, on ajoute ou on retire la classe "filled" selon s'il est vide ou non
            .on('input.filled', function () {
                $(this).toggleClass('filled', this.value.length > 0);
            });
    },

};


var popin = {

    selector: "#page-popin",

    open: function (html) {
        $(this.selector).remove();

        $('body')
            .append(html)
            .addClass('popin-opened');

        overlay.show();

        this.setListeners();
    },


    close: function () {
        $(this.selector).fadeOut(200).remove();

        $('body').removeClass('popin-opened');

        overlay.hide();
    },

    setListeners: function () {
        var $this = this;
        $(this.selector)
            .on('click', '.close-popin > a', function (e) {
                e.preventDefault();
                $this.close();
            });

        if ($('.overlay').hasClass('visible')) {
            $(this.selector)
                .on('click', function (e) {
                    if (!$(e.target).closest($('#page-popin').find('.content')).length) {
                        e.preventDefault();
                        $this.close();
                    }
                });
        }
    },


};

var retourHautPage = {
    init: function () {
        var $this = this;

        if (!window.matchMedia("(max-width: 992px)").matches) {

            // Retour Haut de page
            $(window).scroll(function () {
                if ($(this).scrollTop() > 150) {
                    $('#retourHautDePage').fadeIn();
                } else {
                    $('#retourHautDePage').fadeOut();
                }
            });

            $('#retourHautDePage').on('click', function (e) {
                $('body,html').animate({scrollTop: 0}, 500);
                return false;
            });
        }
    }
};

var closeBandeauOperations = {
    init: function() {
        var $this = this;

        if (localStorage.getItem('closeBandeauOperations')) {
            if (parseInt(localStorage.getItem('closeBandeauOperations')) < $.now() - (15*24*60*60)) {
                localStorage.removeItem('closeBandeauOperations');
            }
        }
        else {
            $('a.closeBandeauOperations').parent().removeClass('d-none');
            $('a.closeBandeauOperations')
                .on('click', function(e) {
                    e.preventDefault();
                    localStorage.setItem('closeBandeauOperations', '1');
                    $('a.closeBandeauOperations').parent().addClass('d-none');
                });
        }
    }
};


(function ($) {

    // Vu que dans PatternLab on est dans une iframe, on doit faire référence à top.
    window.alert = top.alert;
    window.confirm = top.confirm;
    window.prompt = top.prompt;


    anchorsFix.init(); 
    carousel.init();
    addCheckout.init();
    filledInputs.init();
    retourHautPage.init();
    closeBandeauOperations.init();

})(jQuery);

